/**
 * Links the Reach's bridge scan to M2 (M3 plan §7 item 7, slice R22j): with the career in the Reach, R held on a
 * relay target is M2's targeted scan and shows its repair list, and any selected target blocks the deep scan.
 * Runs after the career feature (which provides `m2`) and the Reach feature; the link looks `m2` up on every read,
 * so it also holds before the career starts. Nothing to do outside the Reach.
 */
import type { GameContext, GameFeature } from '../../app/feature'
import { FEATURE_ORDER } from '../../app/feature'
import { findBridgeScan, m2ScanLink } from '../../bridge/m2/scan'

/** Right after the Reach feature (160): the career (150) has provided `m2` by then. */
const ORDER = FEATURE_ORDER.reach + 1

const feature: GameFeature = {
  name: 'bridgeScan',
  order: ORDER,
  init(ctx: GameContext): void {
    if (ctx.reach === null) return
    const scan = findBridgeScan(ctx.reach.subsystems)
    if (scan === null) return
    const services = ctx.services
    scan.link(m2ScanLink(() => services.maybe('m2')))
  },
}

export default feature
